(() => {
  const initialize = (scope = document) => {
    const roots = scope.matches?.('[data-hueys-homepage]') ? [scope] : scope.querySelectorAll('[data-hueys-homepage]');
    roots.forEach(root => {
      if (root.dataset.hueysInitialized) return;
      root.dataset.hueysInitialized = 'true';
      const toggle = root.querySelector('.hueys-menu-toggle');
      const navigation = root.querySelector('.hueys-nav');
      if (!toggle || !navigation) return;
      const setOpen = open => {
        toggle.setAttribute('aria-expanded', String(open));
        navigation.classList.toggle('hueys-open', open);
      };
      toggle.addEventListener('click', () => setOpen(toggle.getAttribute('aria-expanded') !== 'true'));
      navigation.addEventListener('click', event => { if (event.target.closest('a')) setOpen(false); });
      root.addEventListener('keydown', event => {
        if (event.key === 'Escape' && toggle.getAttribute('aria-expanded') === 'true') {
          setOpen(false);
          toggle.focus();
        }
      });
      root.classList.add('hueys-ready');
    });
  };
  initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  window.addEventListener('pageshow', async event => {
    if (!event.persisted) return;
    const root = document.querySelector('[data-hueys-homepage]');
    if (!root) return;
    try {
      const response = await fetch(root.dataset.cartJson, { credentials: 'same-origin', headers: { Accept: 'application/json' } });
      if (!response.ok) return;
      const cart = await response.json();
      if (Number.isInteger(cart.item_count)) root.querySelectorAll('[data-hueys-cart-count]').forEach(count => { count.textContent = cart.item_count; });
    } catch {}
  });
})();
